// import i18n from 'i18next';
import i18n from 'all-in-one-web-header-footer/dist/utils/i18n';
import zh from './zh';
import en from './en';

const namespace = 'portal';

if (!i18n?.options?.ns?.includes(namespace) && i18n.isInitialized) {
    i18n.addResources('en-US', namespace, en);
    i18n.addResources('zh-HK', namespace, zh);
}

export default i18n;
